import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import {
  nbfCustomerAccount,
  nbfCustomers,
  paymentUpdate
} from "../../api/restApi";
import {
  EncodeLevel3Code,
  getAccountCodeForCustomer
} from "../../components/Accounts/Account/HelperClass";
import { PaymentOptions } from "../../components/Accounts/Account/Utlis";
import { CreateNewPaymentModal } from "../../components/modals/PaymentModal";
import {
  customersData,
  setCustomers,
} from "../../store/reducer/customersSlice";
import { setPayment } from "../../store/reducer/paymentSlice";
import { saveLevel3 } from "../../utils/endPoints";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import {
  VoucherItem,
  VoucherItemType,
  VoucherType,
  createAccountVoucher,
} from "../../utils/vouchers/vouchersHelper";
import TablePayment from "./TablePayment";
const Customer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { customers } = useAppSelector(customersData);
  const dispatch = useAppDispatch();
  const collectionName = "Customer";
  const level_3 = useAppSelector((state) => state.accountLevels.level3);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const nbfCustomerInfo = async () => {
    let customers = await nbfCustomers();
    dispatch(setCustomers(customers));
  };

  const handleCreateNewRow = async (values) => {
    try {
      // console.log('*********',values)

      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }
      let tempArray = level_3.filter(function (el) {
        return el.fullcode.startsWith("07-006");
      });
      console.log(tempArray);
      let code = EncodeLevel3Code(customers.length + 1);
      console.log(code);
      if (values.arrearAmount === undefined) {
        values.arrearAmount = 0;
      }
      await setDoc(doc(db, "Customer", code), { ...values, id: code });
      await setDoc(doc(db, "Payment", code), {
        arrearAmount: values.arrearAmount,
        history: [],
        selectedCustomer: {},
      });

      console.log(values.arrearAmount);
      let cust = {
        ...values,
        type: "CLIENT",
        freeze: "NO",
        customer_id: code,
        description: values.name_english,
        l1code: "07",
        l2code: "07-006",
        code: code,
        fullcode: "07-006-" + code,
        name: values.name_english,
        address: values.address_english,
        contact: "234",
        debit: values.arrearAmount >= 0 ? values.arrearAmount : "",
        credit: values.arrearAmount < 0 ? values.arrearAmount : "",
        amount: Math.abs(values.arrearAmount),
        transactionType: values.arrearAmount >= 0 ? "Debit" : "Credit",
      };
      await saveLevel3(cust.fullcode, cust);

      toast.success("Successfully add new customer !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      nbfCustomerInfo();
    } catch (error) {
      // console.log(error);
      console.log(error);
      toast.error("Failed to add new customer!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  useEffect(() => {});
  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    try {
      let id = row.getValue("id").toString();
      // Replace undefined or null values with empty string
      Object.keys(values).forEach(key => {
        if (values[key] === undefined || values[key] === null) {
          values[key] = "";
        }
      });
      await updateDoc(doc(db, collectionName, id), values);
      toast.success("Successfully updated customer!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      nbfCustomerInfo(); // Refresh the customer info
    } catch (error) {
      console.log(error);
      toast.error("Failed to update customer!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); // Exit editing mode
  };
  

  const nbfPaymentInfo = async () => {
    let customerAcccount = await nbfCustomerAccount();
    console.log(customerAcccount);
    dispatch(setPayment(customerAcccount));
  };

  const handleCreateNewRow1 = async (values) => {
    console.log(values);

    if (parseFloat(values.amountPaid + "") <= 0) {
      alert("Please enter valid data");
      return;
    }

    console.log(level_3, values.selectedCustomer.id);

    let level3Code = getAccountCodeForCustomer(
      level_3,
      values.selectedCustomer.id
    );

    console.log(level3Code, values.selectedCustomer.id);

    try {
      const response = await paymentUpdate({
        id: values.selectedCustomer.id,
        amountPaid: values.amountPaid,
        paymentMode: values.paymentMode,
      });
      console.log(
        values.paymentMode.value,
        level3Code,
        values.selectedCustomer.name_english,
        values.amountPaid
      );
      //
      try {
        let type =
          values.paymentMode.value === PaymentOptions.Cash
            ? VoucherType.cashReceived
            : VoucherType.bankReceived; //on delivered always received in cash.
        await createAccountVoucher(type, [
          new VoucherItem({
            transaction: VoucherItemType.debit,
            amount: values.amountPaid,
            code:
              values.paymentMode.value === PaymentOptions.Cash
                ? "07-001-0001"
                : "07-002-0001",
            particular:
              values.paymentMode.value === PaymentOptions.Cash
                ? "cash payment"
                : "bank payment",
            Discription:
              values.paymentMode.value === PaymentOptions.Cash
                ? "cash payment"
                : "bank payment",
            type,
          }),

          new VoucherItem({
            transaction: VoucherItemType.credit,
            amount: values.amountPaid,
            code: level3Code,
            particular: values.selectedCustomer.name_english,
            description: "Bill paid on delivery",
            type,
          }),
        ]);
        toast.success("Successfully add new customer !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfPaymentInfo();
      } catch (error) {
        console.log(error);
        toast.error("Failed to update payment !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      return;
    } catch (error) {
      console.log(error);
      toast.error("Failed to update payment !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "name_english",
      header: "English Name",
      size: 140,
    },
    {
      accessorKey: "arrearAmount",
      header: "Arrears",
      size: 140,
      enableEditing: false, //disable editing on this column
    },
    {
      accessorKey: "delivery_charges",
      header: "Delivery Charges",
      size: 140,
    },
    {
      accessorKey: "name_urdu",
      header: "Urdu Name",
      size: 140,
    },
    {
      accessorKey: "address_english",
      header: "Address English",
      size: 140,
    },
    {
      accessorKey: "address_urdu",
      header: "Address Urdu",
      size: 140,
    },
    {
      accessorKey: "whatApp",
      header: "WhatApp",
      size: 140,
    },
    // {
    //   accessorKey: "ownerNumber",
    //   header: "Owner Number",
    //   size: 140,

    // },
    {
      accessorKey: "city_english",
      header: "City English",
      size: 140,
    },
    {
      accessorKey: "city_urdu",
      header: "City Urdu",
      size: 140,
    },
  ]);
  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
      <TablePayment
          setCreateModalOpen={setCreateModalOpen}
          setPaymentModalOpen={setPaymentModalOpen}
          tableData={customers}
          columns={columns}
          csvFileName="customers"
          handleSaveRowEdits={handleSaveRowEdits}
        ></TablePayment>
        {/* <MaterialTable
          tableData={customers}
          columns={columns}
          csvFileName="customers"
          setCreateModalOpen={setCreateModalOpen}
          setPaymentModalOpen={setPaymentModalOpen}
          handleSaveRowEdits={handleSaveRowEdits}
        ></MaterialTable> */}
        <CreateNewPaymentModal
          columns={[]}
          open={paymentModalOpen}
          onClose={() => setPaymentModalOpen(false)}
          onSubmit={handleCreateNewRow1}
        />
      </Stack>
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit }) => {
  const initialValues = {
    // Address: '',
    // City: '',
    // Name: '',
    // id: '',
    // Email: ''
  };
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    setValues(initialValues);
  }, []);

  const handleSubmit = async () => {
    onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Create New Product</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            {columns.map((column) => {
              // Remove columns from new update
              if (column.accessorKey !== "id") {
                return (
                  <TextField
                    key={column.accessorKey}
                    label={column.header}
                    name={column.accessorKey}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                  />
                );
              }
            })}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Create New Customer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Customer;
